import { asNumber, asString, isObject } from "./model-utils";

class GoogleConfiguration {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.mapKey = asString(json.map_key ?? json.mapKey);
  }

  static fromJson(json: any) {
    return isObject(json) ? new GoogleConfiguration(json) : json;
  }
}

class PaystackConfiguration {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.publicKey = asString(json.public_key ?? json.publicKey);
  }

  static fromJson(json: any) {
    return isObject(json) ? new PaystackConfiguration(json) : json;
  }
}

class OrganisationFee {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.basic = asNumber(json.basic);
    this.business = asNumber(json.business);
    this.enterprise = asNumber(json.enterprise);
    this.custom = asNumber(json.custom);
  }

  static fromJson(json: any) {
    return isObject(json) ? new OrganisationFee(json) : json;
  }
}

class ProcessingFee {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.user = asNumber(json.user);
    this.organisation = OrganisationFee.fromJson(json.organisation);
  }

  static fromJson(json: any) {
    return isObject(json) ? new ProcessingFee(json) : json;
  }
}

class ContactSupport {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.mobile = asString(json.mobile);
    this.email = asString(json.email);
  }

  static fromJson(json: any) {
    return isObject(json) ? new ContactSupport(json) : json;
  }
}

class PlanQuota {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.paymentPlanCost = asNumber(json.paymentPlanCost);
    this.newIdentityCardQuota = asNumber(json.newIdentityCardQuota);
    this.adminQuota = asNumber(json.adminQuota);
    this.supportQuota = asNumber(json.supportQuota);
    this.changeIdentityCardQuota = asNumber(json.changeIdentityCardQuota);
  }

  static fromJson(json: any) {
    return isObject(json) ? new PlanQuota(json) : json;
  }
}

class PlanBilling {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.currency = asString(json.currency);
    this.newIdentityUnitPrice = asNumber(json.newIdentityUnitPrice);
    this.adminUnitPrice = asNumber(json.adminUnitPrice);
  }

  static fromJson(json: any) {
    return isObject(json) ? new PlanBilling(json) : json;
  }
}

class CommunityPlan {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.name = asString(json.name);
    this.processingPercentage = asNumber(json.processingPercentage);
    this.quota = PlanQuota.fromJson(json.quota);
  }

  static fromJson(json: any) {
    return isObject(json) ? new CommunityPlan(json) : json;
  }
}

export class Configuration {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.paystack = PaystackConfiguration.fromJson(json.paystack);
    this.google = GoogleConfiguration.fromJson(json.google);
    this.processingFee = ProcessingFee.fromJson(json.processingFee);
    this.support = ContactSupport.fromJson(json.support);
    this.billing = PlanBilling.fromJson(json.billing);
    this.basicQuota = PlanQuota.fromJson(json.quota?.basic);
    this.freeQuota = PlanQuota.fromJson(json.quota?.free);
    this.customQuota = PlanQuota.fromJson(json.quota?.custom);
    this.businessQuota = PlanQuota.fromJson(json.quota?.business);
    this.enterpriseQuota = PlanQuota.fromJson(json.quota?.enterprise);
    this.communityPlan = CommunityPlan.fromJson(json.communityPlan);
  }

  static fromJson(json: any) {
    return isObject(json) ? new Configuration(json) : json;
  }
}
